import React from 'react'
import {
  DetailsImg,
  DetailsInfo,
  DetailsContent,
  DetailsInfoText,
  GradientContainer,
} from './Details.style'
import useProduct from 'store/SingleProductProvider'

const Details = props => {
  const {
    product: { image },
  } = useProduct()
  const { details } = props

  const formatDescription = htmlString => {
    if (!htmlString) return []

    const parser = new DOMParser()
    const doc = parser.parseFromString(htmlString, 'text/html')
    const paragraphs = doc.querySelectorAll('p')

    const specs = Array.from(paragraphs)
      .map(p => {
        const text = (p.textContent || p.innerText).trim()
        if (!text || text === '&nbsp;') return null

        if (text.includes(':')) {
          const [label, value] = text.split(':').map(item => item.trim())
          return label && value ? { label, value } : null
        }
        return null
      })
      .filter(Boolean)

    const totalParagraphs = Array.from(paragraphs).filter(p => {
      const text = (p.textContent || p.innerText).trim()
      return text && text !== '&nbsp;'
    }).length

    return specs.length > 0 && specs.length === totalParagraphs ? specs : null
  }

  const specs = formatDescription(details.description)

  return (
    <DetailsContent>
      <DetailsInfo>
        {details.description && (
          <>
            <DetailsImg>
              <img src={image || ''} alt="product details" />
            </DetailsImg>
            <DetailsInfoText>
              <h2
                id="product-details"
                className="text-base font-medium !text-[#232323] flex justify-center !pt-32 sm:pt-6 sm:pb-4 sm:mx-2.5 text-center min-[1100px]:justify-start !ml-0"
              >
                დამატებითი ინფორმაცია
              </h2>

              {specs ? (
                <GradientContainer>
                  {specs.map((item, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center p-2 border-b border-red-200/40 last:border-b-0 hover:bg-white/70 transition-all duration-300"
                    >
                      <span className="text-sm w-1/2 text-left">
                        {item.label}
                      </span>
                      <span className="text-sm w-1/2 text-left">
                        {item.value}
                      </span>
                    </div>
                  ))}
                </GradientContainer>
              ) : (
                <div
                  className="prose prose-sm text-gray-700"
                  dangerouslySetInnerHTML={{ __html: details.description }}
                />
              )}
            </DetailsInfoText>
          </>
        )}
      </DetailsInfo>
    </DetailsContent>
  )
}

export default Details
